export const getYear = (state) => state.dashboard.year
